import { useState } from "react";
import { api, payload } from "./lib/api";
import type { SiteModule } from "./types";

const catalog: Array<{ key: SiteModule; title: string; description: string; ready: boolean; paid?: boolean }> = [
  { key: "restaurant_bookings", title: "Prenotazioni ristorante", description: "Agenda, disponibilità, tavoli, note e notifiche.", ready: true },
  { key: "restaurant_menu", title: "Menu ristorante", description: "Categorie, piatti, prezzi e disponibilità.", ready: true },
  { key: "customer_crm", title: "Marketing e clienti", description: "Rubrica, consensi, visite e segmenti.", ready: true },
  { key: "escape_bookings", title: "Prenotazioni escape", description: "Esperienze, location, slot e blocchi incrociati.", ready: true },
  { key: "social_gallery", title: "Lavori e Instagram", description: "Galleria progetti e sincronizzazione social.", ready: true },
  { key: "seo_intelligence", title: "SEO / GEO Intelligence", description: "Dashboard Search Console, score, opportunità e blog. È lo stesso pannello su tutti i siti del gestionale.", ready: true },
  { key: "short_rental", title: "Affitti brevi", description: "Richieste degli ospiti, calendario unificato delle case e chiusure date.", ready: true },
];

export default function ModulesPanel({ siteId, initial, onSaved }: { siteId: string; initial: SiteModule[]; onSaved: (modules: SiteModule[]) => void }) {
  const [selected, setSelected] = useState<Set<SiteModule>>(() => new Set(initial));
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  function toggle(key: SiteModule) {
    setSelected((current) => {
      const next = new Set(current);
      if (next.has(key)) next.delete(key); else next.add(key);
      return next;
    });
    setNotice("");
  }

  async function save() {
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const result = await api<{ modules: SiteModule[] }>(`/api/sites/${siteId}/modules`, payload("PUT", { modules: [...selected] }));
      setSelected(new Set(result.modules));
      onSaved(result.modules);
      setNotice("Moduli aggiornati. La navigazione del cliente ora riflette questa configurazione.");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Impossibile aggiornare i moduli");
    } finally {
      setBusy(false);
    }
  }

  return <section className="modules-panel">
    <header><div><p className="eyebrow indigo">Prodotto modulare</p><h3>Funzioni disponibili al cliente</h3><p>Il core Universe resta sempre attivo. Qui scegli soltanto gli strumenti verticali necessari a questo progetto.</p></div><span>{selected.size} attivi</span></header>
    {notice && <div className="notice success">{notice}</div>}
    {error && <div className="notice error">{error}</div>}
    <div className="module-list">
      {catalog.map((item, index) => <label key={item.key} className={`${selected.has(item.key) ? "enabled" : ""} ${!item.ready ? "planned" : ""} ${item.paid ? "paid" : ""}`}>
        <span className="module-index">{String(index + 1).padStart(2, "0")}</span>
        <span><strong>{item.title}{item.paid ? <em className="module-paid">A pagamento</em> : null}</strong><small>{item.description}</small></span>
        {item.ready ? <input type="checkbox" checked={selected.has(item.key)} onChange={() => toggle(item.key)} /> : <em>In sviluppo</em>}
      </label>)}
    </div>
    <footer><p>Analytics, editor, media, checklist SEO di base, utenti e integrazioni restano nel core. SEO / GEO Intelligence si sblocca qui per sito, dopo il pagamento.</p><button className="primary" disabled={busy} onClick={save}>{busy ? "Salvataggio…" : "Salva moduli"}</button></footer>
  </section>;
}
